import React, { Component } from 'react';
import ReactDOM from 'react-dom'; // eslint-disable-line
import PropTypes from 'prop-types';
import _ from 'lodash';
import '../../../stylesheets/pages/components/ScrollUpArrow.less';

class ScrollUpArrow extends Component {
  constructor(props) {
    super(props);

    this.updateContainerSizes = _.throttle(this.updateContainerSizes.bind(this), 8);
    this.scrollToTop = this.scrollToTop.bind(this);

    this.state = {
      containerWidth: 0,
      containerHeight: 0,
      containerTop: 0
    };
  }

  componentWillMount() {
    window.addEventListener('scroll', this.updateContainerSizes);
    window.addEventListener('resize', this.updateContainerSizes);
    // Animations and dynamic non-event handler driven container resizes (state changes)
    // require a more active resizing method.
    this.intervalId = setInterval(this.updateContainerSizes, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateContainerSizes);
    window.removeEventListener('resize', this.updateContainerSizes);
    clearInterval(this.intervalId);
  }

  updateContainerSizes() {
    const { tableId } = this.props;
    const container = document.getElementById(tableId);
    if (container) {
      const containerBoundingBox = container.getBoundingClientRect();
      this.setState({
        containerWidth: parseFloat(containerBoundingBox.width, 10),
        containerHeight: parseFloat(containerBoundingBox.height, 10),
        containerTop: parseFloat(containerBoundingBox.top, 10),
      });
    }
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  render() {
    const { isSticky } = this.props;
    const { containerHeight, containerTop, containerWidth } = this.state;

    const arrowBottomContainerOffset = window.innerHeight * 0.2;
    const containerBottomBoundry = window.innerHeight - (containerHeight + containerTop + arrowBottomContainerOffset);
    const arrowOffset = containerBottomBoundry < -arrowBottomContainerOffset
      ? window.innerHeight * 0.8
      : Math.abs(containerHeight + containerTop) - arrowBottomContainerOffset;

    return (
      <div
        className={`sticky-up-arrow-container btn ${isSticky ? 'sticky' : ''}`}
        style={{ width: containerWidth, top: `${arrowOffset}px` }}
      >
        <div className="sticky-up-arrow" onClick={this.scrollToTop}>
          <span className="zolaicon-public-chevron-up sticky-up-icon" />
        </div>
      </div>
    );
  }
}

ScrollUpArrow.defaults = {
  container: {}
};

ScrollUpArrow.propTypes = {
  isSticky: PropTypes.bool.isRequired,
  tableId: PropTypes.string,
};

export default ScrollUpArrow;



// WEBPACK FOOTER //
// ./src/components/common/ui/ScrollUpArrow.jsx